import { getGrades } from '@/api/api'
// 格式化学习时间
export const getFormatLearnTime = (second) => {
    let min = Math.floor(second / 60)
    let sec = second % 60
    if(min < 60) {
        return `${min}分${sec}秒`
    } else {
        let hour = Math.floor(second / 3600)
        min = Math.floor((second % 3600) / 60)
        return `${hour}时${min}分${sec}秒`
    }
}

export let gradeList = []
// 全局缓存获取年级
export const resetGradeList = () => {
    gradeList = []
}
export const getGradesList = async () => {
    if(gradeList.length == 0) {
        let res = await getGrades()
        gradeList = res.data.data
        return gradeList
    } else {
        return gradeList
    }
}